import * as pdfjsLib from 'pdfjs-dist';

let initialized = false;

function ensurePdfJsConfigured() {
    if (typeof window === 'undefined' || initialized) {
        return;
    }

    pdfjsLib.GlobalWorkerOptions.workerSrc = '/assets/pdf.worker.min.mjs';
    initialized = true;
}

export function getPdfDocument(url: string) {
    ensurePdfJsConfigured();
    return pdfjsLib.getDocument(url);
}
